
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.43 12.98c.044-.325.067-.652.07-.98a7.793 7.793 0 00-.07-.98l2.11-1.65a.5.5 0 00.12-.64l-2-3.46a.5.5 0 00-.61-.22l-2.49 1a7.306 7.306 0 00-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4a.488.488 0 00-.49.42l-.38 2.65a7.683 7.683 0 00-1.69.98l-2.49-1a.488.488 0 00-.61.22l-2 3.46a.493.493 0 00.12.64l2.11 1.65a7.931 7.931 0 00-.07.98c.003.328.026.655.07.98l-2.11 1.65a.5.5 0 00-.12.64l2 3.46a.5.5 0 00.61.22l2.49-1c.517.4 1.085.73 1.69.98l.38 2.65A.488.488 0 0010 22h4a.488.488 0 00.49-.42l.38-2.65a7.683 7.683 0 001.69-.98l2.49 1a.488.488 0 00.61-.22l2-3.46a.5.5 0 00-.12-.64l-2.11-1.65zM12 15.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"}})])
          )
        }
      }
    